import {
  collection,
  DocumentData,
  getDocs,
  query,
  QueryDocumentSnapshot,
  where,
} from 'firebase/firestore';
import { db } from '../firebase';

/** Firestore caps an `in` filter at ten values per query. */
export const FIRESTORE_IN_LIMIT = 10;

export function chunkIds<T>(items: T[], size: number = FIRESTORE_IN_LIMIT): T[][] {
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
}

/**
 * Documents of `collectionName` belonging to any of `caseIds`, fetched as chunked `in` queries.
 *
 * The alternative these calls replace — read the whole collection, drop the rows that belong to
 * someone else's cases — pays for every other counselor's data just to discard it. Billing is
 * per document returned, not per query, so splitting one large read into several narrow ones
 * costs strictly less as long as the id list is narrower than the collection.
 */
export async function getDocsByCaseIds(
  collectionName: string,
  caseIds: string[]
): Promise<QueryDocumentSnapshot<DocumentData>[]> {
  const uniqueIds = Array.from(new Set(caseIds.filter(Boolean)));
  if (uniqueIds.length === 0) return [];

  const docs: QueryDocumentSnapshot<DocumentData>[] = [];
  for (const idChunk of chunkIds(uniqueIds)) {
    const snapshot = await getDocs(
      query(collection(db, collectionName), where('caseId', 'in', idChunk))
    );
    snapshot.forEach((docSnap) => docs.push(docSnap));
  }
  return docs;
}
